import { RenderStateStruct, WordArtRenderProps } from '../../type';

export function renderLt({
    renderStateStruct,
    rectTextList,
}: {
    renderStateStruct: RenderStateStruct;
    rectTextList: WordArtRenderProps['rectTextList'];
}) {
    const { scheduleRatio } = renderStateStruct;
    const ltList = rectTextList.filter((rectText: any) => rectText.rectLineThrough);

    ltList.forEach((rectText: any, id) => {
        renderStateStruct.ltStructList.push({
            id,
            width: (rectText.width * scheduleRatio) >> 0,
            height: (rectText.height * scheduleRatio * 0.07) >> 0,
            offset: {
                x: rectText.localBounds.x * scheduleRatio,
                // eslint-disable-next-line max-len
                y: (rectText.localBounds.y * scheduleRatio) + (rectText.height * scheduleRatio * 0.47),
            },
            detail: rectText,
            cmds: undefined,
        });
    });
}
